import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AtsGuid } from '@ats/utility';
import { CmEventService } from '@cm/core/system';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CmInterceptHeaders } from '../models';

@Injectable({
	providedIn: 'root',
})
export class CmLoadingInterceptor implements HttpInterceptor {
	constructor(private events: CmEventService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const bypassLoadIndicator = req.headers.has(CmInterceptHeaders.Type.BypassLoadIndicator);
		if (bypassLoadIndicator) {
			req = req.clone({
				headers: req.headers.delete(CmInterceptHeaders.Type.BypassLoadIndicator),
			});
		}

		const reqKey = !bypassLoadIndicator ? AtsGuid.New() : null;
		if (reqKey) {
			this.events.handleLoadingChange(reqKey);
		}

		return next.handle(req).pipe(
			finalize(() => {
				if (reqKey) {
					this.events.handleLoadingChange(reqKey, 'END');
				}
			})
		);
	}
}
